import 'select2';
import FormDatepicker from '../modules/form-datepicker';
import Pagination from '../modules/pagination/pagination';

class CalendarSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.select = this.root.querySelector('select');
        this.paginationWrapper = this.root.querySelector('.pagination');
        this.loaderWrapper = this.root.querySelector(
            '.investor-calendar__loader-wrapper'
        );
        this.htmlWrapper = this.root.querySelector(
            '.investor-calendar__list-wrapper'
        );
        this.datePickers = this.root.querySelectorAll(
            '.form-datepicker__input'
        );

        this.selectInstance = [];
        this.paginationInstance = null;
        this.datepickersInstances = [];

        this.page = 1;
        this.perPage = parseInt(this.root.getAttribute('data-per-page'));
        this.selectType = '';
        this.dateFrom = '';
        this.dateTo = '';

        return true;
    }

    init() {
        this.handleSelectInstance();
        this.handleDatePickerInstances();
        this.handlePaginationInstance();
        this.handleSelectListener();
        this.handleDatePickerListeners();
    }

    handleSelectInstance() {
        if (!this.select) return false;
        const settings = JSON.parse(this.select.getAttribute('data-settings'));
        settings['width'] = '100%';
        settings['dropdownCssClass'] = 'no-search';
        this.selectInstance = $(this.select).select2(settings);
    }

    handleDatePickerInstances() {
        if (this.datePickers.length === 0) return false;

        this.datePickers.forEach(datePicker => {
            const instance = new FormDatepicker(datePicker);
            this.datepickersInstances.push(instance);
        });
    }

    handleDatePickerListeners() {
        if (this.datepickersInstances.length === 0) return false;

        this.datepickersInstances.forEach(item => {
            item.root.addEventListener('datepicker-change', e => {
                const { detail, target } = e;

                if (target.getAttribute('name') === 'date_from') {
                    this.dateFrom = detail;
                } else {
                    this.dateTo = detail;
                }

                this.handleFetch();
            });
        });
    }

    handleSelectListener() {
        if (!this.selectInstance) return false;
        const that = this;
        this.selectInstance.on('select2:select', function (e) {
            const selectedIndex = this.selectedIndex;
            const val = this.options[selectedIndex].value;
            that.selectType = val == 0 ? '' : val;
            that.page = 1;
            that.handleFetch();
        });
    }

    handlePaginationInstance() {
        if (!this.paginationWrapper) return false;

        this.paginationInstance = new Pagination(
            this.paginationWrapper,
            this.root
        );

        this.root.addEventListener('pagination-change', e => {
            const { detail } = e;
            this.page = detail;
            this.handleFetch();
        });
    }

    async handleFetch() {
        this.loaderWrapper.classList.add('active');
        try {
            const formData = new FormData(this.root.querySelector('form'));

            formData.append('action', 'handle_calendar_fetch');
            formData.append('page', this.page);
            formData.append('posts_per_page', this.perPage);
            formData.append('selectType', this.selectType);
            formData.append('dateFrom', this.dateFrom);
            formData.append('dateTo', this.dateTo);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            if (!req) return;

            const { html, page, max_num_pages } = await req.json();

            if (html?.length > 0) {
                this.htmlWrapper.innerHTML = html;
                this.paginationInstance.reset(page, parseInt(max_num_pages));
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.htmlWrapper.scrollIntoView();
            this.loaderWrapper.classList.remove('active');
        }
    }
}

const sections = document.querySelectorAll('.investor-calendar');
const initCalendarSections = sections => {
    if (sections) {
        sections.forEach(section => new CalendarSection(section));
    }
};

initCalendarSections(sections);
